import config from '../../../config/config-default';

const DROPIN_SRC =
	'https://js.braintreegateway.com/web/dropin/1.46.0/js/dropin.min.js';

const loadScript = async (src) => {
	return new Promise((resolve) => {
		const script = document.createElement('script');
		script.async = true;
		script.defer = true;
		script.onload = () => {
			resolve();
		};
		document.head.appendChild(script);
		script.src = src;
	});
};

const getClientToken = async () => {
	const response = await fetch(`${config.apiUri}/bookings/?get-token=true`, {
		headers: {
			Accept: 'application/json',
		},
	});

	return response.json();
};

const initCard = async () => {
	if (window[config.globalScope].dropinInstance) return;
	const [token] = await Promise.all([
		getClientToken(),
		loadScript(DROPIN_SRC),
	]);
	window[config.globalScope].dropinInstance =
		await window.braintree.dropin.create({
			authorization: token.data,
			container: '#card-dropin',
			card: {
				cardholderName: {
					required: true,
				},
			},
		});
};

const processCard = async (submitForm, toggleButtons) => {
	try {
		const { nonce } = await window[
			config.globalScope
		].dropinInstance.requestPaymentMethod();
		document.getElementById('card-nonce').value = nonce;
		submitForm();
	} catch (error) {
		// Drop-in shows what is missing or invalid in the card details
		toggleButtons(false);
	}
};

// a nonce can only be charged once, so a failed order needs the card entered again
const resetCard = () => {
	document.getElementById('card-nonce').value = '';
	const { dropinInstance } = window[config.globalScope];
	if (dropinInstance) dropinInstance.clearSelectedPaymentMethod();
};

export { initCard, processCard, resetCard };
